import { Spinner } from "@sellar-io/components";
import type { BusinessGetResponseType } from "@sellar-io/api-v2/types";
import { type ReactNode } from "react";
import { ErrorMessage } from "../../../../components/errorMessage/ErrorMessage";
import { apiV2AssertError } from "../../../../hooks/api/v2/apiV2Request";

export const EmptyBusinessBoundary = ({
  isLoading,
  error,
  business,
  children,
}: {
  isLoading: boolean;
  error: unknown;
  business: BusinessGetResponseType | undefined;
  children: (business: BusinessGetResponseType) => ReactNode;
}) => {
  if (isLoading)
    return (
      <div className="flex items-center justify-center">
        <Spinner />
      </div>
    );

  if (error) {
    return (
      <ErrorMessage>
        {apiV2AssertError(error)?.response?.data.message}
      </ErrorMessage>
    );
  }

  if (!business) {
    return <ErrorMessage>Cannot find business</ErrorMessage>;
  }

  return children(business);
};
